export const countries = [
    {
        label: 'Без территориальной принадлежности',
        value: 'global'
    },
    {
        label: 'Россия',
        value: 'ru'
    },
    {
        label: 'Украина',
        value: 'ua'
    },
    {
        label: 'Узбекистан',
        value: 'uz'
    },
    {
        label: 'Беларусь',
        value: 'by'
    },
    {
        label: 'Казахстан',
        value: 'kz'
    },
    {
        label: 'Киргизия',
        value: 'kg'
    },
    {
        label: 'Иран',
        value: 'ir'
    },
    {
        label: 'Индия',
        value: 'in'
    },
    {
        label: 'Китай',
        value: 'cn'
    },
    {
        label: 'Эфиопия',
        value: 'et'
    },
    {
        label: 'Австрия',
        value: 'at'
    },
    {
        label: 'Азербайджан',
        value: 'az'
    },
    {
        label: 'Албания',
        value: 'al'
    },
    {
        label: 'Аргентина',
        value: 'ar'
    },
    {
        label: 'Армения',
        value: 'am'
    },
    {
        label: 'Бангладеш',
        value: 'bd'
    },
    {
        label: 'Болгария',
        value: 'bg'
    },
    {
        label: 'Бразилия',
        value: 'br'
    },
    {
        label: 'Великобритания',
        value: 'gb'
    },
    {
        label: 'Венесуэла',
        value: 've'
    },
    {
        label: 'Вьетнам',
        value: 'vn'
    },
    {
        label: 'Германия',
        value: 'de'
    },
    {
        label: 'Греция',
        value: 'gr'
    },
    {
        label: 'Грузия',
        value: 'ge'
    },
    {
        label: 'Дания',
        value: 'dk'
    },
    {
        label: 'Египет',
        value: 'eg'
    },
    {
        label: 'Израиль',
        value: 'il'
    },
    {
        label: 'Индонезия',
        value: 'id'
    },
    {
        label: 'Ирак',
        value: 'iq'
    },
    {
        label: 'Ирландия',
        value: 'ie'
    },
    {
        label: 'Испания',
        value: 'es'
    },
    {
        label: 'Италия',
        value: 'it'
    },
    {
        label: 'Йемен',
        value: 'ye'
    },
    {
        label: 'Камбоджа',
        value: 'kh'
    },
    {
        label: 'Канада',
        value: 'ca'
    },
    {
        label: 'Корея',
        value: 'kr'
    },
    {
        label: 'Куба',
        value: 'cu'
    },
    {
        label: 'Латвия',
        value: 'lv'
    },
    {
        label: 'Литва',
        value: 'lt'
    },
    {
        label: 'Малайзия',
        value: 'my'
    },
    {
        label: 'Мексика',
        value: 'mx'
    },
    {
        label: 'Молдавия',
        value: 'md'
    },
    {
        label: 'Мьянма',
        value: 'mm'
    },
    {
        label: 'Нидерланды',
        value: 'nl'
    },
    {
        label: 'Норвегия',
        value: 'no'
    },
    {
        label: 'ОАЭ',
        value: 'ae'
    },
    {
        label: 'Пакистан',
        value: 'pk'
    },
    {
        label: 'Польша',
        value: 'pl'
    },
    {
        label: 'Португалия',
        value: 'pt'
    },
    {
        label: 'Румыния',
        value: 'ro'
    },
    {
        label: 'Саудовская Аравия',
        value: 'sa'
    },
    {
        label: 'Сербия',
        value: 'rs'
    },
    {
        label: 'Сингапур',
        value: 'sg'
    },
    {
        label: 'Сирия',
        value: 'sy'
    },
    {
        label: 'Словакия',
        value: 'sk'
    },
    {
        label: 'Словения',
        value: 'si'
    },
    {
        label: 'Сомали',
        value: 'so'
    },
    {
        label: 'США',
        value: 'us'
    },
    {
        label: 'Таджикистан',
        value: 'tj'
    },
    {
        label: 'Тайланд',
        value: 'th'
    },
    {
        label: 'Танзания',
        value: 'tz'
    },
    {
        label: 'Турция',
        value: 'tr'
    },
    {
        label: 'Филиппины',
        value: 'ph'
    },
    {
        label: 'Финляндия',
        value: 'fi'
    },
    {
        label: 'Франция',
        value: 'fr'
    },
    {
        label: 'Черногория',
        value: 'me'
    },
    {
        label: 'Чехия',
        value: 'cz'
    },
    {
        label: 'Швейцария',
        value: 'ch'
    },
    {
        label: 'Швеция',
        value: 'se'
    },
    {
        label: 'Шри-Ланка',
        value: 'lk'
    },
    {
        label: 'Эстония',
        value: 'ee'
    },
    {
        label: 'Япония',
        value: 'jp'
    }
]
